<template>
  <div class="video-wrapper">
    <div class="input-area">
      <textarea rows="4" cols="50" type="textarea" v-model="videoUrl"></textarea>
      <button color="blue" @click="reload">{{ $t('Reload') }}</button>
    </div>
    <video width="520" auto muted controls id="replay-video">
      <source :src="videoUrl" type="video/mp4" />
      {{ $t('Your browser does not support the video tag') }}
    </video>
  </div>
</template>
<script>
export default {
  data: () => {
    return {
      player: null,
      videoUrl: null,
    };
  },
  mounted() {
    const { url } = this.$route.query;
    this.videoUrl = url;
    this.player = document.getElementById('replay-video');
  },
  methods: {
    reload() {
      this.player.load();
    },
  },
};
</script>
<style lang="scss">
.video-wrapper {
  height: 100%;
  width: 100%;
  background: #fff;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;

  .input-area {
    width: 520px;
    margin-top: 100px;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;

    font-size: 20px;
    align-items: flex-end;

    textarea {
      width: 520px;
    }

    button {
      @include load-more;
      width: 100px;
      margin: 20px 0;
      align-self: flex-end;
    }
  }
}
</style>
